module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6">\r\n    <div>\r\n\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="town">Town</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="town" placeholder="Town" required=""\r\n                       value="'+
((__t=( address.town ))==null?'':__t)+
'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label">State</label>\r\n            <div class="col-md-9">\r\n                <div id="state-select"></div>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="zip">Zip code</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="zip" placeholder="Zip code" required=""\r\n                       value="'+
((__t=( address.zip ))==null?'':__t)+
'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="address-input">Address</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="address-input" placeholder="Address line" required=""\r\n                       value="'+
((__t=( address.address ))==null?'':__t)+
'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="usage">Usage</label>\r\n            <div class="col-md-9">\r\n                <select id="usage" data-placeholder="Usage">\r\n                    <option value=""></option>\r\n                    ';
 _.each(_.keys(addressUsages), function(key){ 
__p+='\r\n                    <option value="'+
((__t=( key ))==null?'':__t)+
'"  ';
 if (address.usage==key) { 
__p+='  selected="true" ';
 } 
__p+=' >'+
((__t=( addressUsages[key] ))==null?'':__t)+
'</option>\r\n                    ';
 }) 
__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save-address">'+
((__t=( mode ))==null?'':__t)+
'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel-address">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/address-form.html
// module id = 260
// module chunks = 0